export default {"src":"/_next/static/media/profile-edit.58c89d83.svg","height":72,"width":72};